/** VH-222: shared number formatting for the system view. */
export const fmt = (v, digits = 1) => {
  if (v == null || Number.isNaN(v)) return '—'
  const f = 10 ** digits
  return Math.round(v * f) / f
}
export const pct = (v) => (v == null ? '—' : `${Math.round(v * 100)} %`)
